import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { Layout } from './components/layout/Layout';
import { Toaster } from './components/ui/sonner';

// Pages
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { ProjectOverview } from './pages/ProjectOverview';
import { Projects } from './pages/Projects';
import { Personas } from './pages/Personas';
import { PersonaEditor } from './pages/PersonaEditor';
import { Heuristics } from './pages/Heuristics';
import { HeuristicDetail } from './pages/HeuristicDetail';
import { TechnicalAnalyses } from './pages/TechnicalAnalyses';
import { AnalysisEditor } from './pages/AnalysisEditor';
import { Reports } from './pages/Reports';
import Logistics from './pages/Logistics';
import Products from './pages/Products';
import { Integrations } from './pages/Integrations';
import { Diagnostics } from './pages/Diagnostics';
import { DiagnosticDetail } from './pages/DiagnosticDetail';
import { PublicAnalysisView } from './pages/PublicAnalysisView';
import { SystemSettings } from './pages/SystemSettings';
import { ClientPortal } from './pages/ClientPortal';

// Client portal (separate session, no AppContext)
import { PortalLogin } from './portal/PortalLogin';
import { PortalChangePassword } from './portal/PortalChangePassword';
import { PortalLayout } from './portal/PortalLayout';
import { PortalIndex, PortalNativePage, PortalAnaliseDetail } from './portal/PortalPages';

import './App.css';

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* Client Portal (separate session) */}
          <Route path="/portal/login" element={<PortalLogin />} />
          <Route path="/portal/trocar-senha" element={<PortalChangePassword />} />
          <Route path="/portal" element={<PortalLayout />}>
            <Route index element={<PortalIndex />} />
            <Route path="analises/:id" element={<PortalAnaliseDetail />} />
            <Route path=":key" element={<PortalNativePage />} />
          </Route>

          {/* Public route - no auth required */}
          <Route path="/compartilhar/analise-tecnica/:token" element={<PublicAnalysisView />} />
          
          <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
          <Route path="/project-overview" element={<Layout><ProjectOverview /></Layout>} />
          <Route path="/projects" element={<Layout><Projects /></Layout>} />
          <Route path="/personas" element={<Layout><Personas /></Layout>} />
          <Route path="/personas/new" element={<Layout><PersonaEditor /></Layout>} />
          <Route path="/personas/:personaId/edit" element={<Layout><PersonaEditor /></Layout>} />
          <Route path="/heuristics" element={<Layout><Heuristics /></Layout>} />
          <Route path="/heuristics/:id" element={<Layout><HeuristicDetail /></Layout>} />
          <Route path="/diagnostics" element={<Layout><Diagnostics /></Layout>} />
          <Route path="/diagnostics/:id" element={<Layout><DiagnosticDetail /></Layout>} />
          <Route path="/analyses" element={<Layout><TechnicalAnalyses /></Layout>} />
          <Route path="/analyses/new" element={<Layout><AnalysisEditor /></Layout>} />
          <Route path="/analyses/:id" element={<Layout><AnalysisEditor /></Layout>} />
          <Route path="/reports" element={<Layout><Reports /></Layout>} />
          <Route path="/logistics" element={<Layout><Logistics /></Layout>} />
          <Route path="/products" element={<Layout><Products /></Layout>} />
          <Route path="/integrations" element={<Layout><Integrations /></Layout>} />
          <Route path="/system-settings" element={<Layout><SystemSettings /></Layout>} />
          <Route path="/client-portal" element={<Layout><ClientPortal /></Layout>} />
          
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/signup" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AppProvider>
  );
}

export default App;
